
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "c214094e42ef86b7c0e87068280f17dcb83d5bc7",
  "nuxt": {
    "buildId": "ea85abf0-f167-4328-a22f-356bf92f6687"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
